export class EmployeeBuyerMappingReq{
    employeeName: string;
    buyerName: string;
    createdUser : string;
    id?: number;
    constructor(employeeName: string, buyerName: string,createdUser : string,id?: number,){
        this.employeeName = employeeName
        this.buyerName = buyerName
        this.createdUser = createdUser
        this.id = id
    }
}